export default "__VITE_ASSET__b985a9d3__"